<template>
  <div
    :id="`wrapper_${index}`"
    class="my-10 md:my-20"
  >
    <NuxtLink :to="prismic.asLink(slice.primary.link) ?? ''">
      <div
        class="group w-full cursor-pointer p-10 text-charcoal-100"
        :class="useTheme(slice.primary.theme)"
      >
        <h2 class="text-header2 md:text-desktop-header2">
          {{ slice.primary.title }}
        </h2>
        <div class="flex flex-col items-end justify-end md:flex-row">
          <PrismicRichText
            :field="slice.primary.content"
            class="mt-10 text-body-copy text-charcoal-100 md:mr-20 md:max-w-[50vw] md:text-desktop-body-copy"
          />
          <ArrowRight class="w-10 group-hover:animate-bouncex md:w-20" />
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type { Content } from "@prismicio/client";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ArrowRight from "~/assets/svgs/arrow_right.svg";

gsap.registerPlugin(ScrollTrigger);

const prismic = usePrismic();

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
const props = defineProps(
  getSliceComponentProps<Content.PromoBoxSlice>([
    "slice",
    "index",
    "slices",
    "context",
  ]),
);

onMounted(() => {
  if (props.index != 0) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `#wrapper_${props.index.toString()}`,
        start: "top 80%",
        end: "bottom bottom",
        scrub: true,
      },
    });

    tl.from(`#wrapper_${props.index.toString()}`, { y: "50px", opacity: 0, duration: 0.5 });
  }
});
</script>
